import type { Meta, StoryObj } from "@storybook/react";

import type { AppointmentAvatarCardProps } from "@/ui/components/schedule/booking/AppointmentAvatarCard";
import ProviderAvatarCard from "@/ui/components/schedule/booking/AppointmentAvatarCard";
import { AvatarUserTypeValues } from "@/ui/core/Avatar";
import { joinTestIDs } from "@/utils/string.util";

const StoryMeta: Meta<AppointmentAvatarCardProps> = {
  title: "Components/Schedule/Booking/Appointment Avatar Card",
  component: ProviderAvatarCard,
  argTypes: {
    infoLabel: { control: "text" },
    isAppUser: { control: "boolean" },
    isDisabled: { control: "boolean" },
    isSelected: { control: "boolean" },
    onSelect: { action: "selected" },
    pronouns: { control: "object" },
    subtitle: { control: "text" },
    userId: { control: "text" },
    userName: { control: "text" },
    userType: {
      control: "select",
      options: Object.values(AvatarUserTypeValues),
    },
  },
  args: {
    isAppUser: false,
    isDisabled: false,
    isSelected: false,
    pronouns: ["he/they"],
    userId: joinTestIDs("appointment", "avatar-card"),
    userName: "Clover Green",
  },
};

type Story = StoryObj<AppointmentAvatarCardProps>;

const ProviderWithInfo: Story = {
  args: {
    infoLabel: "Available for consultations on diet and exercise",
    subtitle: "Dietitian, RDN",
    userType: "provider",
  },
};

const ProviderWithoutInfo: Story = {
  args: {
    subtitle: "Dietitian, RDN",
    userType: "provider",
  },
};

const Patient = {
  args: {
    subtitle: "Patient",
    userType: "patient",
  },
};

const Support = {
  args: {
    subtitle: "Support",
    userType: "support",
  },
};

export { Patient, ProviderWithInfo, ProviderWithoutInfo, Support };
export default StoryMeta;
